import {
    Box,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import HolidayForm from "./HolidayForm";
import ModalView from "../model/ModelView";
import { Add, Edit, CalendarTodayOutlined, Delete } from "@mui/icons-material";
import authService from "../Auth/AuthService";
import { useTheme, useMediaQuery } from "@mui/material";


export default function HolidayPage() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));

    const [holidays, setHolidays] = useState([]);
    const [mode, setMode] = useState(null); // add | edit | view
    const [selected, setSelected] = useState(null);
    const hasFetched = useRef(false);

    useEffect(() => {
        if (hasFetched.current) return;
        hasFetched.current = true;
        loadData();
    }, []);

    const loadData = async () => {
        const url = authService.pathUrl("GET", "/public-holiday");
        const res = await authService.getAuth(url);
        setHolidays(res || []);
    };

    const openForm = (mode, data = null) => {
        setMode(mode);
        setSelected(data);
    };

    const closeForm = () => {
        setMode(null);
        setSelected(null);
    };

    const handleDelete = async (id) => {
        const url = authService.pathUrl("DELETE", "/public-holiday/" + id);
        const res = await authService.deleteAuth(url);
         loadData();
    }

    const handleSubmit = async (data) => {
        if (mode === "add") {
            const url = authService.pathUrl("POST", "/public-holiday");
            const res = await authService.postAuth(url, data);
            setHolidays([...holidays, { ...res }]);
        } else if (mode === "edit") {
            const url = authService.pathUrl("PUT", "/public-holiday");
            const res = await authService.putAuth(url, data);
            setHolidays(
                holidays.map((h) => (h.id === res.id ? { ...h, ...res } : h))
            );
        }
        closeForm();
    };
    const columns = {
        index: true,
        name: true,
        date: true,
        year: !isMobile,
        type: !isMobile && !isTablet,
        actions: true,
    };

    return (
        <Box
            p={isMobile ? 2 : 3}
            sx={{ width: "100%", maxWidth: "100vw", overflowX: "hidden" }}
        >
            {/* ---------- HEADER ---------- */}
            <Box
                display="flex"
                justifyContent="space-around"
                alignItems="center"
                flexWrap="wrap"
            >
                <Typography variant="h5" fontWeight="bold" color="primary">
                    Holiday Management
                </Typography>

                <IconButton
                    color="warning"
                    onClick={() => openForm("add")}
                    title="Add Holiday"
                >
                    <Add sx={{ border: "2px solid", borderRadius: "10px" }} />
                </IconButton>
            </Box>

            {/* ---------- TABLE ---------- */}
            <TableContainer
                component={Paper}
                sx={{ mt: 2, width: "100%", overflowX: "auto" }}
            >
                <Table size={isMobile ? "small" : "medium"}>
                    <TableHead>
                        <TableRow>
                            {columns.index && <TableCell>#</TableCell>}
                            {columns.name && <TableCell>Name</TableCell>}
                            {columns.date && <TableCell>Date</TableCell>}
                            {columns.year && <TableCell>Year</TableCell>}
                            {columns.type && <TableCell>Type</TableCell>}
                            {columns.actions && <TableCell>Actions</TableCell>}
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {holidays.map((h, index) => (
                            <TableRow key={h.id}>
                                {columns.index && <TableCell>{index + 1}</TableCell>}
                                {columns.name && <TableCell>{h.name}</TableCell>}
                                {columns.date && <TableCell>{h.toDate}</TableCell>}
                                {columns.year && <TableCell>{h.year}</TableCell>}
                                {columns.type && <TableCell>{h.holidayType}</TableCell>}

                                {columns.actions && (
                                    <TableCell>
                                        <IconButton
                                            color="warning"
                                            onClick={() => openForm("view", h)}
                                            title="View Holiday" >
                                            <CalendarTodayOutlined sx={{ fontWeight: "bold", borderRadius: "10px" }} />
                                        </IconButton>
                                        <IconButton
                                            color="warning"
                                            onClick={() => openForm("edit", h)}
                                            title="Edit Holiday" >
                                            <Edit sx={{ border: "2px solid", fontWeight: "bold", borderRadius: "10px" }} />
                                        </IconButton>
                                        <IconButton
                                            color="warning"
                                            onClick={() => handleDelete(h.id)}
                                            title="Delete Holiday" >
                                            <Delete sx={{ border: "2px solid", fontWeight: "bold", borderRadius: "10px" }} />
                                        </IconButton>
                                    </TableCell>
                                )}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            {/* ---------- MODAL ---------- */}
            <ModalView
                size="sm"
                open={Boolean(mode)}
                handleClose={closeForm}
                title={
                    mode === "add"
                        ? "Add Holiday"
                        : mode === "edit"
                            ? "Edit Holiday"
                            : "View Holiday"
                }
                content={
                    <HolidayForm
                        mode={mode}
                        initialData={selected}
                        onSubmit={handleSubmit}
                    />
                }
            />
        </Box>
    );

}